/**
 * closeFlow.ts — the pure drop/close decision for the pipeline board (§5.B),
 * kept out of the component so vitest can pin it without DOM drag events.
 *
 * Closed stages are reachable ONLY via the close command (decision #7): a
 * closed-column drop opens the Close modal, never a bare stage write — the
 * server 400s those. Closed cards do not drag at all: there is no reopen
 * path (a cross-outcome re-close is a named 409).
 */
import type { DealStage } from '../../types'

export type CloseOutcome = 'won' | 'lost'

export type DropAction =
  | { kind: 'none' }
  | { kind: 'move' }
  | { kind: 'close'; outcome: CloseOutcome }

export function isClosedStage(stage: DealStage): boolean {
  return stage === 'Closed Won' || stage === 'Closed Lost'
}

export function dropAction(current: DealStage, target: DealStage): DropAction {
  if (isClosedStage(current)) return { kind: 'none' } // no reopen path
  if (target === current) return { kind: 'none' }
  if (target === 'Closed Won') return { kind: 'close', outcome: 'won' }
  if (target === 'Closed Lost') return { kind: 'close', outcome: 'lost' }
  if (target === 'Unknown') return { kind: 'none' } // never a drop target
  return { kind: 'move' }
}
